import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIORDash = {
    name: 'Overall Risk Dashboard',
    imageUrl: './images/OR_01_Dashboard.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIORRiskgrade = {
    name: 'Overall Risk Grade',
    imageUrl: '../../images/OR_Risk_Grade.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSDash = {
    name: 'DS Dashboard Grade',
    imageUrl: './images/UI_DS_Dash.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIDSRisk = {
    name: 'DS Risk Grade',
    imageUrl: '../../images/UI_DS_Risk.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIORFinimpact = {
    name: 'DS Risk Grade',
    imageUrl: '../../images/ORFinimpact.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIORDWValue = {
    name: 'Sensitive Dark Web Value',
    imageUrl: '../../images/ORSensDataValue.png',
    imageSize: "75%",
    bradius: 20,
  };

const UIORDWValue02 = {
    name: 'Sensitive Dark Web Value',
    imageUrl: '../../images/ORSensDataValue02.png',
    imageSize: "75%",
    bradius: 20,
  };

const UIORRWRecoverycost = {
    name: 'Ransomware Recovery Cost',
    imageUrl: '../../images/ORRWRecoveryCosts.png',
    imageSize: "50%",
    bradius: 40,
  };

const UIORBreachCost = {
    name: 'Ransomware Recovery Cost',
    imageUrl: '../../images/ORBreachCost.png',
    imageSize: "80%",
    bradius: 20,
  };

const UIORResidualCost = {
    name: 'Ransomware Recovery Cost',
    imageUrl: '../../images/ORResidualCost.png',
    imageSize: "75%",
    bradius: 20,
  };

const UIORCompTracker = {
    name: 'Overall Risk Compliance Tracker',
    imageUrl: '../../images/ORCompTracker.png',
    imageSize: "50%",
    bradius: 20,
  };

const UIORKPI = {
    name: 'Overall Risk KPI Program',
    imageUrl: '../../images/ORKPI.png',
    imageSize: "70%",
    bradius: 20,
  };

const UIORKPI02 = {
    name: 'Overall Risk KPI Summary',
    imageUrl: '../../images/ORKPI02.png',
    imageSize: "70%",
    bradius: 20,
  };

const UIORGenmatrix = {
    name: 'Overall Risk Generate Risk Matrix',
    imageUrl: '../../images/ORGenmatrix.png',
    imageSize: "45%",
    bradius: 20,
  };

const UIORRiskmatrix = {
    name: 'Overall Risk Matrix',
    imageUrl: '../../images/ORRiskmatrix.png',
    imageSize: "80%",
    bradius: 20,
  };

const UIORRisktrend = {
    name: 'Risk Trend Chart',
    imageUrl: '../../images/ORRisktrend.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIORDataScans = {
    name: 'Risk Trend Chart',
    imageUrl: '../../images/ORDataScans.png',
    imageSize: "65%",
    bradius: 20,
  };

const UIORMitplans = {
    name: 'Risk Trend Chart',
    imageUrl: '../../images/ORMitplans.png',
    imageSize: "65%",
    bradius: 20,
  };

export const ORDash = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Overall Risk Dashboard</b><br /><br />
      The overall risk dashboard or instance page provides a simplified overview of what is happening within a chosen 
      customer/organization (instance). <br /><br />
      All of the data you see within this dashboard about this customer has been collected, is unique to this 
      customer/organization (instance) and was reported by the onsite sensor. <br /><br />
      In order to populate the overall risk dashboard with key data, simply set up at least one sensor/agent 
      within the chosen organization. From there, the rest is hosted in the CYRISMA cloud infrastructure.

      </div>
      <div style={helpimg}>
      <img
        src={UIORDash.imageUrl}
        alt={'Image of ' + UIORDash.name}
        style={{
          width: UIORDash.imageSize,
          borderRadius: UIORDash.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const ORRiskGrade = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Overall Risk Grade</b><br /><br />
      The overall risk grade is a combined overall performance grade for your instance based on all scans covering 
      data sensitivity, vulnerability, secure baseline scans, and compliance assessment. Essentially, it&rsquo;s telling 
      you the overall risk profile for your instance and whether there have been any improvements or a decline in your 
      risk reduction efforts for your instance since the last reporting period (Month or Quarter). <br /><br />
      The main grade shown under Risk Grade is for the current reporting period, and the grade shown just below that 
      in a smaller font size is for the previous reporting period.  <br /><br />Please note, you can set the periods 
      as monthly or quarterly by clicking on M or Q right above the Overall Risk Grade. 
      </div>
      <div style={helpimg}>
      <img
        src={UIORRiskgrade.imageUrl}
        alt={'Image of ' + UIORRiskgrade.name}
        style={{
          width: UIORRiskgrade.imageSize,
          borderRadius: UIORRiskgrade.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const ORRiskbycat = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Risk Grades by Category</b><br /><br />
      As mentioned previously, the overall risk grade is a combination of the overall scans shown below that were 
      performed for your instance. <br /><br />
      <ul style={{marginLeft: '4em'}}>
      <li>Data Sensitivity – Grade based on the ratio of sensitive vs. non-sensitive data discovered plus a severity rating 
      based on the risk value of the sensitive data. </li>
      <li>Vulnerability – Grade based on the number of vulnerabilities (as defined as documented CVEs - Common 
      Vulnerabilities and Exposures). CVEs are individually rated according to severity, and the combined overall 
      severity is reflected in the score values. </li>
      <li>Secure Baseline - Grade based on actual configuration practice compared against established configuration 
      practice (Based on CI Security Benchmarks, or DISA - STIG benchmark) for operating system hardening. </li>
      <li>Compliance - Grade based on aggregate performance in AD Monitoring and Microsoft Secure Score </li>
      </ul>
      </div>
      <div style={helpimg}>
      <img
        src={UIORRiskgrade.imageUrl}
        alt={'Image of ' + UIORRiskgrade.name}
        style={{
          width: UIORRiskgrade.imageSize,
          borderRadius: UIORRiskgrade.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ORRiskfin = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Risk Monetization by Threat Type / Financial Risk Impact</b><br /><br />
      Within this section, you can ascertain within the chosen instance the financial impact that CYRSIMA has not only 
      discovered but evaluated regarding Dark Web Data Value, Ransomware Recovery Costs, Breach Notification Costs 
      and Residual Risk Costs.

      </div>
      <div style={helpimg}>
      <img
        src={UIORFinimpact.imageUrl}
        alt={'Image of ' + UIORFinimpact.name}
        style={{
          width: UIORFinimpact.imageSize,
          borderRadius: UIORFinimpact.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ORDWValue = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Sensitive Data Dark Web Value</b><br /><br />
      To establish what this data is worth on the dark web at a glance, simply click on the <b>Sensitive Data Dark Web 
      Value</b> box. From here, CYRISMA provides a clear overview covering a ninety-day time span illustrating what 
      categories of data were discovered and what the targets were discovered on as shown here. <br /><br />
      With CYRISMA, you have the capability to drill down even further by clicking on each of the time spans. 
      From here, you will be able to view what categories of data were discovered, the number of files, the number 
      of hits, the monetary value, as well as what targets the data were discovered on as shown below. With 
      this feature, your organization and instance can get a very good idea of what the monetary value of 
      this sensitive data is worth on the dark web.

      </div>
      <div style={helpimg}>
      <img
        src={UIORDWValue.imageUrl}
        alt={'Image of ' + UIORDWValue.name}
        style={{
          width: UIORDWValue.imageSize,
          borderRadius: UIORDWValue.bradius,
        }}
      /><br />
      <img
        src={UIORDWValue02.imageUrl}
        alt={'Image of ' + UIORDWValue02.name}
        style={{
          width: UIORDWValue02.imageSize,
          borderRadius: UIORDWValue02.bradius,
        }}
      />      
      </div>
    </div>
  );
};


export const RWRecovery = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Ransomware Recovery Cost</b><br /><br />
      If your organization or instance were to suffer from a ransomware outbreak, CYRISMA provides a clear overview of what those 
      recovery costs could potentially be, breaking it down by the number of computers, downtime for the number of employees affected, 
      and value of the data level on the dark web. All of these are accumulated to provide an overall downtime cost. <br /><br />
      To view this breakdown, simply click on the <b>Ransomware Recovery Costs</b> box, and a pop-up similar to the one shown 
      here will appear for your review.<br /><br />
      Please note: <br /><br />
      <ul style={{marginLeft: '4em'}}>
      <li>It doesn&rsquo;t consider the lost sales or lost business for your organization or instance - whoever is impacted. </li>
      <li>Over the course of a typical twenty-one-day ransomware outage, the downtime for the employees and the recovery 
      time for the computers would equal the total downtime cost amount that will be shown within the pop-up. </li>
      </ul>
      </div>
      <div style={helpimg}>
      <img
        src={UIORRWRecoverycost.imageUrl}
        alt={'Image of ' + UIORRWRecoverycost.name}
        style={{
          width: UIORRWRecoverycost.imageSize,
          borderRadius: UIORRWRecoverycost.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const Breachcost = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Breach Notification Cost</b><br /><br />
      If there is a requirement for your organization to do a breach notification (if it were to suffer a data breach), 
      simply click on the <b>Breach Notification Cost</b>box and the following &lsquo;What is your Notification Cost Estimate&rsquo;
      pop-up will appear.<br /><br />
      We strongly recommend that you continuously monitor these associated costs, as they may change from time to time. <br /><br />
      Within the &lsquo;What is your Notification Cost Estimate&rsquo; pop-up, you have the ability to deep dive into any of the record 
      set categories that may be displayed. An example of this, you can see the Bank Accounts data (selected) in the screenshot 
      above on the right. <br /><br />
      With this example, you can establish the individual cost associated per breach category relating to bank accounts. 
      This could enable your organization to apply a fact-based decision-making methodology to protect those clients who have 
      been impacted going forward. 

      </div>
      <div style={helpimg}>
      <img
        src={UIORBreachCost.imageUrl}
        alt={'Image of ' + UIORBreachCost.name}
        style={{
          width: UIORBreachCost.imageSize,
          borderRadius: UIORBreachCost.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const Residualcost = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Residual Risk Cost</b><br/><br/>
      As one of our main aims is to help your organization reduce risk, you are also presented with a residual risk cost calculator. <br/><br/>
      Simply click on the <b>Residual Risk Cost</b> box, and a pop-up will appear like the one shown here.<br/><br/>
      The top 3 indicators are based on your use of the CYRISMA platform and will automatically turn green when you start using 
      those features. <br/><br/>However, along with CYRISMA helping your organization reduce risk, we also ask you direct questions 
      on how you can reduce your risk even further in the bottom section. As you complete each section with a yes, your risk is 
      further reduced by putting solutions into practice that address these questions.
      </div>
      <div style={helpimg}>
      <img
        src={UIORResidualCost.imageUrl}
        alt={'Image of ' + UIORResidualCost.name}
        style={{
          width: UIORResidualCost.imageSize,
          borderRadius: UIORResidualCost.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const Comptracker = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Compliance Tracker</b><br /><br />
      Depending on which compliance metric you are trying to adhere to, the CYRISMA compliance tracker measures how well your 
      instance is meeting its compliance targets, represented as a percentage. <br/><br/>
      You can deep dive into each regulatory body applicable to your instance to determine if they are either meeting or failing 
      on any of their compliance requirements.  

      </div>
      <div style={helpimg}>
      <img
        src={UIORCompTracker.imageUrl}
        alt={'Image of ' + UIORCompTracker.name}
        style={{
          width: UIORCompTracker.imageSize,
          borderRadius: UIORCompTracker.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ProgramKPI = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Security Program KPI</b><br /><br />
      The purpose of the Information Security Program KPI is to illustrate how well your risk is being reduced over time. 
      In addition, it also indicates the performance of your mitigation plans: <br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Performance Index - indicator showing risk reduction or risk increase over time </li>
      <li>To deep dive into these indicators simply click on View Snapshot and you will be presented with a snapshot 
      review like the one shown here.</li>
      </ul><br /><br /><br /><br /><br /><br />
      From here, you can establish the performance of each metric over your chosen reporting period based on the number of 
      alerts, open plans/alerts, and whether these plans have been completed or not.

      </div>
      <div style={helpimg}>
      <img
        src={UIORKPI.imageUrl}
        alt={'Image of ' + UIORKPI.name}
        style={{
          width: UIORKPI.imageSize,
          borderRadius: UIORKPI.bradius,
        }}
      /><br />
      <img
        src={UIORKPI02.imageUrl}
        alt={'Image of ' + UIORKPI02.name}
        style={{
          width: UIORKPI02.imageSize,
          borderRadius: UIORKPI02.bradius,
        }}
      />   
      </div>
    </div>
  );
};


export const Riskmatrix = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Target Risk Matrix</b><br /><br />
      The Target Risk Matrix provides a performance breakdown by target. Each asset, whether it be desktop or server, 
      shows the overall score for each risk group and summarizes this into a score for Impact, Likelihood and Overall Risk. <br/><br/>
      For example, if we select desktop/laptop as a chosen target type: <br/><br/>
      Then click <b>Generate Matrix</b> to be presented with a target risk matrix report like the one shown here.<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
      This matrix shows a breakdown based on a per-target level. Here you can establish how each target is performing when 
      it comes to data sensitivity, vulnerabilities, overall risk grade, etc. Essentially, the matrix is to illustrate what&srquo;s 
      happening at a more granular target level.

      </div>
      <div style={helpimg}>
      <img
        src={UIORGenmatrix.imageUrl}
        alt={'Image of ' + UIORGenmatrix.name}
        style={{
          width: UIORGenmatrix.imageSize,
          borderRadius: UIORGenmatrix.bradius,
        }}
      /><br/><br/>
      <img
        src={UIORRiskmatrix.imageUrl}
        alt={'Image of ' + UIORRiskmatrix.name}
        style={{
          width: UIORRiskmatrix.imageSize,
          borderRadius: UIORRiskmatrix.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const Trendchart = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Risk Trend Chart</b><br /><br />
      The Risk Trend chart allows you to view the performance of each risk group (sensitivity, vulnerability, and baseline) 
      based on the CYRISMA risk levels A - F through a line chart representation. You can either select the performance of 
      each category individually or simply turn any category off if not required by clicking on the checkboxes against 
      any one of the categories shown here. 


      </div>
      <div style={helpimg}>
      <img
        src={UIORRisktrend.imageUrl}
        alt={'Image of ' + UIORRisktrend.name}
        style={{
          width: UIORRisktrend.imageSize,
          borderRadius: UIORRisktrend.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const Datascans = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Scan Summaries</b><br /><br />
      The Scan Summary section provides you with an overview of the scans in progress and the scans completed 
      in the current reporting period. You can also see the number of Targets (Devices) that haven’t been scanned until now. 
      The Scans in Progress section shows you additional information on the scans currently 
      in progress including scan names, due dates and the percentage progress on each.  <br /><br />
      Similar information for other scan types is available by clicking the &rsquo;Data Scans &gt;&lsquo; link at the top
      left of this section.

      </div>
      <div style={helpimg}>
      <img
        src={UIORDataScans.imageUrl}
        alt={'Image of ' + UIORDataScans.name}
        style={{
          width: UIORDataScans.imageSize,
          borderRadius: UIORDataScans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const Mitigationplans = () => {
  return (
    <div style={helpcanvas}>
      <div></div>
      <div style={helptitle}><b>Mitigation Plans</b><br /><br />
      The Mitigation Plans dashboard provides you with a quick snapshot of all open assigned mitigation plans for your 
      organization/instance, the number of plans that have been completed or are on schedule, and the number of plans 
      that are running behind schedule. You can also view and further drill-down into latest mitigations in progress, 
      the individuals responsible for each plan, due dates, and the percentage progress on each. 

      </div>
      <div style={helpimg}>
      <img
        src={UIORMitplans.imageUrl}
        alt={'Image of ' + UIORMitplans.name}
        style={{
          width: UIORMitplans.imageSize,
          borderRadius: UIORMitplans.bradius,
        }}
      />
      </div>
    </div>
  );
};


